var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-gap-x-3"},_vm._l((_vm.digits),function(digit){return _c('input',{key:digit,class:_vm.inputClass,attrs:{"type":"number","maxlength":"1"},on:{"keyup":_vm.keyUp,"keydown":_vm.keyDown}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }